import { panamaHoy } from './costosUtil';
import { PRESETS, type RangoFechas } from './useRangoFechas';
import styles from './RangoFechasBar.module.css';

/** Barra de presets de fechas + rango personalizado. */
export default function RangoFechasBar({ rango }: { rango: RangoFechas }) {
  const { preset, setPreset, customStart, setCustomStart, customEnd, setCustomEnd } = rango;
  return (
    <div className={styles.rangeBar} role="group" aria-label="Rango de fechas">
      {PRESETS.map((p) => (
        <button
          key={p.key}
          type="button"
          aria-pressed={preset === p.key}
          className={`${styles.presetBtn} ${preset === p.key ? styles.presetBtnActive : ''}`}
          onClick={() => setPreset(p.key)}
        >
          {p.label}
        </button>
      ))}
      <button
        type="button"
        aria-pressed={preset === 'custom'}
        className={`${styles.presetBtn} ${preset === 'custom' ? styles.presetBtnActive : ''}`}
        onClick={() => setPreset('custom')}
      >
        Personalizado
      </button>
      {preset === 'custom' && (
        <div className={styles.customRange}>
          <input
            type="date"
            aria-label="Fecha inicial"
            value={customStart}
            max={customEnd}
            onChange={(e) => e.target.value && setCustomStart(e.target.value)}
          />
          <span className={styles.sep}>a</span>
          <input
            type="date"
            aria-label="Fecha final"
            value={customEnd}
            min={customStart}
            max={panamaHoy()}
            onChange={(e) => e.target.value && setCustomEnd(e.target.value)}
          />
        </div>
      )}
    </div>
  );
}
